<script setup lang="ts">
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'MobilePreorderInfo',
})
</script>

<template>
    <div class="info">
        <p>В настоящий момент игра находится на стадии разработки.</p>
        <p>В середине 2024-го года мы запустили <span class="highlighted">закрытое бета-тестирование</span>.</p>
        <p><span class="highlighted">ЗБТ</span> продлится несколько месяцев. За это время мы подготовимся к полноценному запуску: устраним баги, скорректируем интерфейс, улучшим геймплей, отбалансируем экономическую модель.</p>
        <p style="color: wheat;">Ты можешь приобрести <span class="highlighted">пропуск на ЗБТ</span> на странице <router-link to="register">регистрации.</router-link></p>
        <p>В качестве благодарности за поддержку проекта каждый из участников получит разнообразные награды при создании персонажа:</p>

        <ul>
            <li>эксклюзивные аватарки и рамки</li>
            <li>уникальные скины кораблей</li>
            <li>звание «Первопроходца»</li>
            <li>исследовательские зонды</li>
            <li>бусты опыта</li>
            <li>другие ценные бонусы</li>
        </ul>
    </div>
</template>

<style scoped lang="scss">
.info {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
    text-align: left;
    color: white;
    text-shadow: 0 0 10px black;

    background: rgba(0, 0, 0, 0.6);
    border-radius: 10px;
    box-shadow: 0 0 10px 2px black;
    padding: 5px 10px 5px 10px;
}

h5 {
    color: orangered;
}

.highlighted {
    color: #00c4ff;
}

p {
    text-align: left;
    margin-bottom: 7px;
}

ul {
    display: inline-block;
    text-align: left;
    margin: 0;
}

li {
    color: #00f100;
    text-shadow: 0 0 5px black;
    list-style: none; /* Remove default bullets */
}

ul li::before {
    content: "\2022";
    text-shadow: 0 0 5px black;
    color: #01c201;
    font-weight: bold;
    font-size: 10px;
    display: inline-block;
    width: 1em;
    margin-left: -1em;
}
</style>
